import(/* webpackMode: "eager" */ "/vercel/path0/inaction/src/app/(appLayout)/inaction/viewPlay/[playId]/ClientPage.tsx")